import { gql } from "@apollo/client";

export const AssetIoTConnectionEditValues = gql`
    query AssetIoTConnectionEditValues ($id: ID!) {
        assetLocation (id: $id) {
            id
            iotConnection {
                id
                assetType
                gateway {
                    id
                    imei
                    gateway {
                        id
                        imei
                    }
                }
                operatingFrequency
                operatingPressure
                oilCategory
                oilType
                gasBallast
                gasBallastType
                catalogVariant
                acousticEnclosure
                registeredLastServiceMaintenance
                registeredLastOverhaulReManufacturing
                registeredRunningHoursSinceLastServiceMaintenance
                registeredRunningHoursSinceLastOverhaulReManufacturing
                lastServiceMaintenance
                lastOverhaulReManufacturing
                runningHoursSinceLastServiceMaintenance
                runningHoursSinceLastOverhaulReManufacturing
            }
        }
    }
`;
